<template>
	<div class="InputPassword">
		<div v-if="showErrorIcon" class="InputPassword_passwordIcon">
			<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M11.0007 1.83301C6.02446 1.83301 1.83398 6.02348 1.83398 10.9997C1.83398 15.9759 6.02446 20.1663 11.0007 20.1663C15.9768 20.1663 20.1673 16.1068 20.1673 10.9997C20.1673 5.89253 16.1078 1.83301 11.0007 1.83301Z"
					fill="#FF0E3E"
				/>
				<ellipse cx="11.0009" cy="15.0742" rx="1.01852" ry="1.01852" fill="white" />
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M11.0007 7.02734C11.5069 7.02734 11.9173 7.43775 11.9173 7.94401L11.9173 12.0181C11.9173 12.5243 11.5069 12.9348 11.0007 12.9348C10.4944 12.9348 10.084 12.5243 10.084 12.0181L10.084 7.94401C10.084 7.43775 10.4944 7.02734 11.0007 7.02734Z"
					fill="white"
				/>
			</svg>
		</div>
		<div v-else class="InputPassword_passwordIcon">
			<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M6.60156 5.49993C6.60156 3.57614 8.1611 2.0166 10.0849 2.0166H11.9182C13.842 2.0166 15.4016 3.57614 15.4016 5.49993V7.59393C16.9732 7.9307 18.1516 9.32771 18.1516 10.9999V16.4999C18.1516 18.4237 16.592 19.9833 14.6682 19.9833H7.3349C5.4111 19.9833 3.85156 18.4237 3.85156 16.4999V10.9999C3.85156 9.32771 5.02991 7.9307 6.60156 7.59393V5.49993ZM8.06823 7.5166H13.9349V5.49993C13.9349 4.38616 13.032 3.48327 11.9182 3.48327H10.0849C8.97112 3.48327 8.06823 4.38616 8.06823 5.49993V7.5166ZM7.3349 8.98327C6.22112 8.98327 5.31823 9.88616 5.31823 10.9999V16.4999C5.31823 17.6137 6.22112 18.5166 7.3349 18.5166H14.6682C15.782 18.5166 16.6849 17.6137 16.6849 16.4999V10.9999C16.6849 9.88616 15.782 8.98327 14.6682 8.98327H7.3349ZM9.35156 12.8333C9.35156 11.922 10.0903 11.1833 11.0016 11.1833C11.9128 11.1833 12.6516 11.922 12.6516 12.8333C12.6516 13.4811 12.2782 14.0418 11.7349 14.3118V15.5833C11.7349 15.9883 11.4066 16.3166 11.0016 16.3166C10.5966 16.3166 10.2682 15.9883 10.2682 15.5833V14.3118C9.72493 14.0418 9.35156 13.4811 9.35156 12.8333Z"
					fill="white"
				/>
			</svg>
		</div>
		<input
			ref="inputPasswordRef"
			class="c_input"
			type="password"
			:value="modelValue"
			v-bind="$attrs"
			@input="(event) => emit('update:modelValue', (event.target as HTMLInputElement).value)"
		/>
		<div v-if="showToggle" class="InputPassword_toggleIcon" @click.stop="onToggleClick">
			<svg
				class="toggleIcon_show"
				width="30"
				height="30"
				viewBox="0 0 30 30"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M15 5.625C8.75 5.625 3.4125 9.5125 1.25 15C3.4125 20.4875 8.75 24.375 15 24.375C21.25 24.375 26.5875 20.4875 28.75 15C26.5875 9.5125 21.25 5.625 15 5.625ZM15 21.25C11.55 21.25 8.75 18.45 8.75 15C8.75 11.55 11.55 8.75 15 8.75C18.45 8.75 21.25 11.55 21.25 15C21.25 18.45 18.45 21.25 15 21.25ZM15 11.25C12.925 11.25 11.25 12.925 11.25 15C11.25 17.075 12.925 18.75 15 18.75C17.075 18.75 18.75 17.075 18.75 15C18.75 12.925 17.075 11.25 15 11.25Z"
					fill="#777777"
				/>
			</svg>

			<svg
				class="toggleIcon_hide"
				width="30"
				height="30"
				viewBox="0 0 30 30"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M15 8.0875C18.45 8.0875 21.25 10.8875 21.25 14.3375C21.25 14.975 21.125 15.5875 20.95 16.1625L24.775 19.9875C26.5125 18.45 27.8875 16.525 28.75 14.325C26.5875 8.85 21.25 4.9625 15 4.9625C13.4125 4.9625 11.8875 5.2125 10.45 5.675L13.1625 8.3875C13.75 8.2125 14.3625 8.0875 15 8.0875ZM3.3875 3.9125C2.9 4.4 2.9 5.1875 3.3875 5.675L5.85 8.1375C3.825 9.75 2.2125 11.875 1.25 14.3375C3.4125 19.825 8.75 23.7125 15 23.7125C16.9 23.7125 18.7125 23.3375 20.3875 22.6875L23.7875 26.0875C24.275 26.575 25.0625 26.575 25.55 26.0875C26.0375 25.6 26.0375 24.8125 25.55 24.325L5.1625 3.9125C4.675 3.425 3.875 3.425 3.3875 3.9125ZM15 20.5875C11.55 20.5875 8.75 17.7875 8.75 14.3375C8.75 13.375 8.975 12.4625 9.3625 11.6625L11.325 13.625C11.2875 13.85 11.25 14.0875 11.25 14.3375C11.25 16.4125 12.925 18.0875 15 18.0875C15.25 18.0875 15.475 18.05 15.7125 18L17.675 19.9625C16.8625 20.3625 15.9625 20.5875 15 20.5875ZM18.7125 13.925C18.525 12.175 17.15 10.8125 15.4125 10.625L18.7125 13.925Z"
					fill="#777777"
				/>
			</svg>
		</div>
	</div>
</template>

<script setup lang="ts">
// core
import { ref, useAttrs } from 'vue';

defineOptions({
	inheritAttrs: false,
});
defineProps<{
	modelValue?: string; // v-model을 사용하기위한 prop
	showToggle?: boolean; // 토글 버튼을 보여줄지 여부
	showErrorIcon?: string;
}>();
const attrs = useAttrs();
const emit = defineEmits(['update:modelValue']);

const inputPasswordRef = ref();

const onToggleClick = () => {
	if (attrs.disabled || attrs.readonly) return;
	if (!inputPasswordRef.value) return;

	inputPasswordRef.value.type = inputPasswordRef.value.type === 'password' ? 'text' : 'password';
};
</script>

<style scoped lang="scss">
.InputPassword {
	position: relative;
	width: 100%;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;

	input {
		height: 4.8rem;
		padding: 0 3.6rem 0rem 3.6rem;
		appearance: textfield;
	}
	.InputPassword_passwordIcon {
		position: absolute;
		top: 50%;
		transform: translate(0, -50%);
		display: flex;
		align-items: center;
		height: 100%;
		aspect-ratio: 1;
		user-select: none;
		left: 1rem;
		svg {
			width: 45%;
			height: 45%;
			margin-right: -5%;
		}
	}
	.InputPassword_toggleIcon {
		position: absolute;
		top: 50%;
		right: 0rem;
		transform: translate(0, -50%);
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		aspect-ratio: 1;
		user-select: none;
		svg {
			width: 40%;
			height: 40%;
		}
	}

	// hide toggle icon
	input[type='password'] + .InputPassword_toggleIcon .toggleIcon_hide {
		display: none;
	}
	input[type='text'] + .InputPassword_toggleIcon .toggleIcon_show {
		display: none;
	}
}
.error {
	input {
		border-color: red;
		box-shadow: none;
	}
}
</style>
